import routes from "./routes";
import { createRouter, createWebHistory } from "vue-router";
import { clearServerErrors } from "~/plugins/formErrors";

const router = createRouter({
  history: createWebHistory(),
  routes, // short for `routes: routes`
});

router.onError((error, to) =>
{
  if (error.message.includes('Failed to fetch dynamically imported module') || error.message.includes("Importing a module script failed"))
  {
    window.location = to.fullPath
  }
})

router.afterEach(clearServerErrors);

router.beforeEach(async (to, from) =>
{
  if (!to.meta.middleware)
  {
    return;
  }

  const middleware = Array.isArray(to.meta.middleware)
    ? to.meta.middleware
    : [to.meta.middleware];

  // Run middleware sequentially. A returned route/error stops the chain;
  // undefined means that navigation may continue.
  for (const mdw of middleware)
  {
    const result = await mdw({ to, from, router });

    if (result !== undefined)
    {
      return result;
    }
  }
});

export default router;
